import {Component, OnInit, ElementRef, ViewChild} from '@angular/core';
import {Consultant} from '../../../models/Consultant.model';
import {ConsultantService} from '../../../services/consultant.service';
import {CnaeService} from '../../../services/cnae.service';
import {CommonHelper} from '../../../shared/helpers/CommonHelper';
import {Router, ActivatedRoute} from '@angular/router';
import {Responsible} from '../../../models/Responsible.model';
import {UserService} from '../../../services/user.service';
import {ContractType} from '../../../shared/enums/ContractType';
import {FormGroup, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import { AwsService } from '../../../services/aws.service';
import {HonorariumType} from '../../../shared/enums/HonorariumType';
import {Toast, ToastsManager} from 'ng2-toastr';
import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
import { PixKeyType } from '../../../shared/enums/PixKeyType';
import * as moment from 'moment';
import * as _ from 'lodash';
import { CompaniesService } from '../../../services/companies.service';
import { CompanyService } from '../../../services/billing-letter/company.service';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { Contract } from '../../../models/Contract.model';
import { Additive } from '../../../models/Additive.model';
import { TerminationContract } from '../../../models/TerminationContract.model';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../../shared/auth/Roles';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { BankService } from '../../../services/bank.service';
import { PixValidation } from '../../../shared/helpers/PixValidation';
import { BorrowedNote } from '../../../models/BorrowedNote.model';
import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { SelfFillRequestStatus } from '../../../shared/enums/SelfFillRequestStatus';
import { PublicConsultantService } from "../../../services/public-consultant.service";
import { FreshServiceOffboardingForm } from "../../../models/FreshServiceOffboardingForm.model";
import { LeaveTypesOptions, LeaveTypesSubGroup } from "../../../shared/enums/LeaveTypes.enum";
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';

@Component({
    selector: 'app-consultant-edit',
    templateUrl: './consultant-edit.component.html',
    styleUrls: ['./consultant-edit.component.scss']
})
export class ConsultantEditComponent implements OnInit {
    @ViewChild("contractend") contractend: ElementRef;
    @ViewChild("contracthonorarium") contracthonorarium: ElementRef;
    @ViewChild("openModalInfra") openModalInfra: ElementRef;
    @ViewChild("closeModalAdditive") closeModalAdditive: ElementRef;
    @ViewChild("buttonOpenModalContract") buttonOpenModalContract: ElementRef;
    @ViewChild("buttonOpenModalBorrowNote") buttonOpenModalBorrowNote: ElementRef;
    consultant: Consultant = new Consultant();
    responsibles: Responsible[] = new Array<Responsible>();
    filteredResponsibles: Responsible[] = new Array<Responsible>();
    bps: Responsible[] = new Array<Responsible>();
    options: any;
    emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    emailPatternFC = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
    cpfPattern = /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2})$/i;
    accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
    agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
    digitMask = [/[A-Za-z0-9]/];
    consultantForm: FormGroup;
    honorarium: Boolean;
    showSoldHoursValue: Boolean;
    contractGenerated: Boolean;
    distractGenerated: Boolean = false;
    showOperationContract: Boolean;
    consultantSearch = new ConsultantSearch();
    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
    bankCodeMask = [/[0-9]/,/[0-9]/,/[0-9]/];
    errors = [];
    redirect: Boolean = true;
    sendEmailInfra = false;
    sendEmailDepartments = false;
    bondConsultantPJ = false;
    bondConsultantCLT = false;
    blockAdditive = false;
    optionLaptop = 1;
    optionEmail = 1;
    laptopValid = false;
    laptopReturnedChecked = false;
    laptopAccordChecked = false;
    indexModalInfra: Number = 997;
    indexDateContrat: Number = 998;
    indexContractAdditive: Number = 999;
    additiveHistory: Additive = new Additive();
    withoutCompany: Boolean = false;

    distractInProgress: Boolean = false;
    dischargeInProgress: Boolean = false;
    personalDataInvalid: Boolean = false;
    contractDataInvalid: Boolean = false;
    lenderContractDataInvalid: Boolean = false;
    lenderPersonalDataInvalid: Boolean = false;
    hidePrivateData: Boolean = false
    isUserFinances: Boolean = false
    isUserAccounting: Boolean = false;
    isUserPeople: boolean = false;
    isUserBp: boolean = false;

    GUARDS = GUARDS;
    canSave: Boolean = true;
    allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.JUDICIARY, GUARDS.DP, GUARDS.ACCOUNTING, GUARDS.PEOPLE, GUARDS.BUSINESSPARTNER];
    notAllowedDivisionRoles = [GUARDS.GOVERNANCE, GUARDS.PEOPLE];
    isBlockedByDivision: boolean = false;
    user;

    fileList;
    fileListTerminationForm;
    selectedFiles:FileList;
    downloadUrl:string = '';
    downloadUrlTerminationConsultant:string = '';
    currentStep = 'contracts';
    optionDistract = 2;
    additiveOption: Number = 0;

    customers: any = [];
    customersLoaded: any = [];
    skills: any = [];
    skillsDropdown = { list: [], options: null, selected: [] };
    skillAux: string = '';

    consultantId: string;

    loading;
    cnaes = [];
    occupations = [];
    documentsClickSign = [];
    blockLoggedUser: Boolean = false;
    banks : any = [];
    pixKeyVerifyMethod : any;
    pixCpfValid : Boolean;
    pixCnpjValid : Boolean;
    bankCode: number;
    bankName: string;
    bankCountry: string;
    bankSapCode: number;
    bank_id: string;
    show: Boolean = false;
    auxSupportCenter: string = undefined

    typeAdtiveModal: any;
    typeContractModal: string;
    funcContractModal: Function;

    reloadDocModal: Boolean = true;
    isDischargeOrDistract: string;
    textMask;
    startedBorrowedNote: boolean = false;
    isBorrowedDeclaration: boolean = false;
    lenderConsultant: Consultant = new Consultant();
    validateBorrowedInvoiceNoteDate: boolean = false;
    activeBorrowedInvoiceNote: boolean = false;
    borrowInvoiceNoteInProgress: boolean = false;
    consultantsBorrowInvoice: Consultant[] = [];
    excellenceCenters: Array<ExcellenceCenter> = [];
    supportCenters: Array<ExcellenceCenter> = [];

    showHourValue: boolean = false;
    showTotalValue: boolean = false;
    showHourValueBenefits: boolean = false;
    showMensalHours: boolean = false;
    disableHourValue: boolean = false;

    showBtnNewAdditiveReadjustment: boolean = true;
    showBtnNewAdditiveRenew: boolean = true;
    showBtnNewAdditiveChangeCompany: boolean = true;

    disableContractFields: Boolean = false;
    validDateAdditive: Boolean = false;
    consultantSelfFill: any;
    updateApprovedConsuntant: any;
    idToUpdateApproved: string;
    indexToUpdateApproved: number;
    selfFillData: any;
    hasRequiredExcellenceCenter: boolean = false;
    newAdditiveIncluded: boolean = false;

    allowedToFillFinishBondForms = false;
    blockDpToAccessConsultantPJ: boolean = false;
    leaveTypesSubGroups = [];
    pendingGovOrDpApproval = false;
    ContractTypes = ContractType;
    completedOffboardingForm: boolean = false;
    typeFunctionModal: number;
    additiveValueAdjustmentInProgress: boolean = false;
    additiveChangeCompanyInProgress: boolean = false;

    allowedToChangeBond = [GUARDS.GOVERNANCE, GUARDS.BUSINESSPARTNER, GUARDS.DP];
    canChangeConsultantBond = true;

    constructor(private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private formBuilder: FormBuilder,
        private toastr: ToastsManager,
        public consultantService: ConsultantService,
        public commonHelper: CommonHelper,
        private awsService:AwsService,
        private companyService: CompanyService,
        private companiesService: CompaniesService,
        private dropDownItemFactory: DropdownItemFactory,
        private dropDownSettingFactory: DropdownSettingsFactory,
        private localStorage: LocalStorage,
        private cnaeService:CnaeService,
        private bankService: BankService,
        public pixValidation: PixValidation,
        private publicConsultantService: PublicConsultantService,
        private excellenceCentersService: ExcellenceCentersService,
        private LeaveTypesGroups: LeaveTypesSubGroup,
        private errorHandler: ErrorHandlerProvider,
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.user = this.localStorage.retrieve('user');
        this.consultantId = this.route.snapshot.params['id'];

        this.consultantForm = this.formBuilder.group({
            name: [null, Validators.required],
            begin:[null, Validators.required],
            email: [null, [Validators.required, Validators.email]],
            fcEmail: [null, [Validators.required, Validators.email]],
            contractKind: [null, [this.validateSelectOption]],
            rg: [null, [Validators.required]],
            cpf: [null, [Validators.required, Validators.pattern(this.cpfPattern)]],
            sex: [null, [this.validateSelectOption]],
            civilStatus: [null, [this.validateSelectOption]],
            cep: [null, null],
            address: [null, null],
            number: [null, null],
            district: [null, null],
            city: [null, null],
            country: [null, null],
            state: [null, null],
            responsible: [null, [this.validateSelectOptionResponsible]],
            bp: [null, [this.validateSelectOptionBP]],
            keyPix:[null,[this.validateKeyPix]],
            bank: [null, [this.validateSelectOptionBank]],
            agency: [null, Validators.required],
            account: [null, Validators.required],
            digit: [null, Validators.required],
            born: [null, Validators.required],
            consultantStart: [null, Validators.required],
            cellPhone: [null, Validators.maxLength(20)],
            position: [null, null],
            excellenceCenter: [null, [this.validateSelectOptionExcellenceCenter]],
            supportCenter: [null, null]
        });

        this.consultant = await this.consultantService.getById(this.consultantId);
        this.consultant.personal.born = moment(this.consultant.personal.born).format("DDMMYYYY");
        this.consultant.contract.begin = moment(this.consultant.contract.begin).format("DDMMYYYY");
        this.consultant.consultantStart = moment(this.consultant.consultantStart).format("DDMMYYYY");
        if(this.consultant.contract.end)
            this.consultant.contract.end = moment(this.consultant.contract.end).format("DDMMYYYY");
        if(this.consultant.contract.regularizationDate)
            this.consultant.contract.regularizationDate = moment(this.consultant.contract.regularizationDate).format("DDMMYYYY");
        if(this.consultant.consultantEnd)
            this.consultant.consultantEnd = moment(this.consultant.consultantEnd).format("DDMMYYYY");
        if(this.consultant.contract.termination.start)
            this.consultant.contract.termination.start = moment(this.consultant.contract.termination.start).format("DDMMYYYY");
        if(this.consultant.contract.termination.end)
            this.consultant.contract.termination.end = moment(this.consultant.contract.termination.end).format("DDMMYYYY");
        if(this.consultant.contract.termination.generationDate)
            this.consultant.contract.termination.generationDate = moment(this.consultant.contract.termination.generationDate).format("DDMMYYYY");

        if(this.consultant.contract.additivesHistory && this.consultant.contract.additivesHistory.length > 0){
            this.consultant.contract.additivesHistory = this.consultant.contract.additivesHistory.map(additive => {
                if(additive.date) additive.date = moment(additive.date).format("DDMMYYYY");
                return additive;
            });
        }

        if(this.consultant.contractsHistory && this.consultant.contractsHistory.length > 0){
            this.consultant.contractsHistory = this.consultant.contractsHistory.map(contract => {
                if(contract.begin) contract.begin = moment(contract.begin).format("DDMMYYYY");
                if(contract.end) contract.end = moment(contract.end).format("DDMMYYYY");

                if(contract.customers && contract.customers.length > 0){
                    contract.customers = contract.customers.map(customer => {
                        if(customer.start) customer.start = moment(customer.start).format("DDMMYYYY");
                        if(customer.end) customer.end = moment(customer.end).format("DDMMYYYY");
                        return customer;
                    })
                }

                return contract;
            });
        }

        if(this.consultant.contract.customers && this.consultant.contract.customers.length > 0){
            this.consultant.contract.customers = this.consultant.contract.customers.map(customer => {
                if(customer.start) customer.start = moment(customer.start).format("DDMMYYYY");
                if(customer.end) customer.end = moment(customer.end).format("DDMMYYYY");
                return customer;
            })
        }

        if(this.consultant.payment.typePix == 0) {
            this.consultantForm.get("keyPix").disable();
        }

        if(this.consultant.payment.keyPix){
            this.textMask = {mask: false}
        }

        if(this.consultant.supportCenter){
            this.auxSupportCenter = this.consultant.supportCenter._id
        }

        this.consultant.contract.additivesHistory.forEach(adt => {
            if(adt.pendingApproval || adt.pendingGovApproval)
                this.blockAdditive = true;
        });

        this.laptopValid = (this.consultant.contract.termination.laptopReturned || this.consultant.contract.termination.returnAgreement) ? true : false;

        this.customers = await this.companyService.getAll();
        this.customers = _.orderBy(this.customers,[company => company.name.toUpperCase()]);

        this.skills = await this.consultantService.getAllSkills();
        this.skillsDropdown.options = this.dropDownSettingFactory.build({text:'Skills'});
        this.skillsDropdown.list = this.dropDownItemFactory.build({source:this.skills});
        this.skillsDropdown.selected = this.dropDownItemFactory.build({source:this.consultant.skills});

        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT) {
            this.disableHourValue = true;
            this.showHourValue = true;
            this.showTotalValue = true;
            this.showHourValueBenefits = true;
            this.showSoldHoursValue = true;
            this.showMensalHours = true;
            this.consultantForm.get('position').setValidators(null);
        }
        if (kind === ContractType.PJ && honor === HonorariumType.OpenHour) {
            this.showHourValue = true;
            this.disableHourValue = false;
            this.showMensalHours = false;
            this.showTotalValue = false;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators([this.validateSelectOption]);
        }

        if (kind === ContractType.PJ && honor === HonorariumType.ClosedHour) {
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showTotalValue = true;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators([this.validateSelectOption]);
        }

        if (kind === ContractType.Intern || kind === ContractType.Others) {
            this.showHourValue = true;
            this.disableHourValue = false;
            this.showMensalHours = true;
            this.showTotalValue = true;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators(null);
        }

        if(!this.laptopValid && !this.consultant.active){
            this.bondConsultantPJ = true;
        }

        this.banks = await this.bankService.getBanks();
        this.responsibles = await this.userService.getAllUsersAsResponsibles();
        this.filteredResponsibles = this.responsibles.filter(responsible => responsible.username !== this.consultant.fcEmail) //previne que o consultor seja definido como responsável por ele mesmo
        this.bps = [...this.responsibles];
        this.options = this.commonHelper.getDatePickerOptions();

        //set status contract
        if(!this.consultant.contract.generated){
            if(this.consultant.contract.cnpj != '' && this.consultant.contract.companyName != '')
                this.consultant.contract.contractStatus = 1
            else
                this.consultant.contract.contractStatus = 5
        }

        await this.getS3Files();
        if(this.fileList.length > 0){
            this.download(this.fileList[0].Key);
        }

        this.occupations = await this.consultantService.getAllContractProfile();
        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeConsultant]);
        this.distractGenerated = this.consultant.contract.termination.documentGenerated ? true : false;

        if(this.consultant.contract.companyName == '' || this.consultant.contract.companyName == null){
            this.withoutCompany = true;
        }

        //validação de usuário logado para bloqueio de dados sensíveis
        this.currentStep = 'personal';
        this.loggedUserValidation();
        this.checkPermissions();

        if (this.consultant.borrowInvoiceNote.lenderId) {
            this.activeBorrowedInvoiceNote = true;
        };

        const allExcellenceCenters = await this.excellenceCentersService.getAll();

        this.excellenceCenters = allExcellenceCenters.filter(center => center.type == 1 );
        this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

        this.supportCenters = allExcellenceCenters.filter(center => center.type == 2);
        this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);

        if(this.route.snapshot && this.route.snapshot.fragment == 'autoFills') {
            this.currentStep = 'autoFills';
            this.getConsultantSelfFill();
        }

        this.leaveTypesSubGroups = [...this.LeaveTypesGroups.leaveTypes] as LeaveTypesOptions[];
        if (!this.consultant.active) {
            this.pendingGovOrDpApproval = this.consultant.contract.termination.pendingDPApproval ||
                this.consultant.contract.termination.pendingGovApproval

            if (this.pendingGovOrDpApproval && this.consultant.contract.kind === ContractType.CLT) {
                await this.getS3FilesConsultantTermination(this.consultant._id);
            }
        };


        this.loading = false;
        if(!this.consultant.payment.typePix) {
            this.consultant.payment.typePix = 0
            this.consultantForm.get("keyPix").disable();
        }

        if(this.consultant.personal.country == 'Brasil') {
            this.consultantForm.get('state').enable();
        } else {
            this.consultantForm.get('state').disable();
        }
    }

    async checkPermissions() {
        let permission = this.user.permission;

        if(!this.allowedRoles.includes(permission)) {
            this.canSave = false;
        }

        if (!this.allowedToChangeBond.includes(this.user.permission))
            this.canChangeConsultantBond = false;

        if(permission  === GUARDS.INFRA || permission === GUARDS.ADMINISTRATIVE){
            this.router.navigate(['consultants', 'public-consultant-edit', this.consultantId])
        } else if(permission == GUARDS.COMMERCIAL) {
            this.isBlockedByDivision = false;
        } else if(permission == GUARDS.FINANCES ){
            this.currentStep = 'personal';
            this.isUserFinances = true ;
        } else if (permission  == GUARDS.RS) {
            this.hidePrivateData = true ;
        } else if(permission == GUARDS.ACCOUNTING) {
            this.currentStep = 'personal';
            this.isUserAccounting = true;
        }

        if (permission === GUARDS.PEOPLE)
            this.isUserPeople = true;
        if (permission === GUARDS.BUSINESSPARTNER) {
            this.isUserBp = true;
        }
        if(this.user.permission  == GUARDS.DP)
        this.blockDpToAccessConsultantPJ = this.consultant.contract.kind === ContractType.PJ;

    }

    validateSelectOptionResponsible(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {responsible: true};

        return null;
    }

    validateSelectOptionBank(control: AbstractControl) {
        if (control.value === '0' || !control.value)
            return {bank: true};

        return null;
    }

    validateSelectOptionBP(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {bp: true};

        return null;
    }

    validateSelectOptionExcellenceCenter(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {excellenceCenter: true};

        return null;
    }

    validateSelectOptionSupportCenter(control: AbstractControl) {
        if (control.value === undefined || control.value == 'undefined')
            return {supportCenter: true};

        return null;
    }

    validateKeyPix(control: AbstractControl){
        if(control.value === undefined || control.value == 'undefined')
           return {keyPix:true}
        return null;
    }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0)
            return {contractKind: true};

        return null;
    }

    trim(name){
        if(this.consultant[name])
            this.consultant[name] = this.consultant[name].trim();
    }
    trimPixKey(){
        if(this.consultant.payment.keyPix)
            this.consultant.payment.keyPix = this.consultant.payment.keyPix.trim();
    }

    async edit() {
        if (this.consultantForm.valid == false) {
            let errors = [];
            Object.keys(this.consultantForm.controls).forEach(control => {
                const controlErrors = this.consultantForm.get(control).errors
                if(controlErrors != null){
                    Object.keys(controlErrors).forEach(error =>{
                        let field = this.getVerboseField(control);
                        if(error == 'email'){
                            errors.push(`${field.verbose}: Formato de e-mail inválido`)
                        }

                        if(
                            error == 'required' ||
                            error == 'responsible' ||
                            error == 'excellenceCenter' ||
                            error == 'bp' ||
                            error == 'bank' ||
                            error == 'pixType' ||
                            error == 'keyPix' ||
                            error == 'contractKind' ||
                            error == 'supportCenter'
                        ) {
                            errors.push(`Preencha o campo ${field.verbose}`)
                        }

                        if(error == 'maxlength'){
                            errors.push(`O campo ${field.verbose} ultrapassa o limite de caracteres`)
                        }

                    });
                }
            });
            this.errors = errors;
            return;
        }
        this.consultant.responsible = this.responsibles.find(x => x._id == this.consultant.responsible._id);
        this.consultant.bp = this.bps.find(x => x._id == this.consultant.bp._id);
        this.consultant.fcEmail = this.consultant.fcEmail.toLowerCase();
        this.consultant.email = this.consultant.email.toLowerCase();
        this.consultant.excellenceCenter = this.excellenceCenters.find(ec => ec._id == this.consultant.excellenceCenter._id);
        this.consultant.supportCenter = this.checkSupportCenter(this.auxSupportCenter);

        if(this.consultant.contract.customers.some(c => !c._id))
            return this.toastr.warning('Há campos obrigatórios na sessão Clientes que não foram preenchidos', 'Erro no módulo Consultor');

        this.consultant.contract.customers = this.consultant.contract.customers.map(c => {
            const customer = this.customers.find(x => x._id === c._id);
            c.name = customer.name || '';
            return c;
        });

        try {

            if(this.documentsInProgressIncomplete())
                return;

            if(this.consultant.active == false){
                if(this.bondConsultantCLT){//CLT
                    this.consultant.active = true;
                    this.consultant.contract.termination = new TerminationContract();
                }
            } else {
                if(this.bondConsultantPJ || this.bondConsultantCLT){
                    if (this.consultant.contract.termination && !this.consultant.contract.termination.cancelEmail && !this.consultant.contract.termination.emailAlternativeRedirect) {
                        return this.toastr.warning("Se a opção de cancelar e-mail for 'Não', preencha qual será o e-mail alternativo de redirecionamento...", 'ATENÇÃO!');
                    }

                    const isHourFilled = !this.consultant.contract.termination.qtdHours;
                    const isHoursFieldInvalid = (!this.isUserBp && this.dischargeInProgress && isHourFilled) || (this.isUserBp && isHourFilled);
                    const isLeaveTypeInvalid = !this.consultant.contract.termination.leaveType || Number(this.consultant.contract.termination.leaveType) == 0;

                    if (this.consultant.active && (isHoursFieldInvalid || isLeaveTypeInvalid)) {
                        let message = this.consultantService.isContractTypePJ(this.consultant) ? 'encerramento de vínculo' : 'inativação';
                        return this.toastr.error(`Para prosseguir com o processo de ${message}, preencha os campos obrigatórios.`, 'ATENÇÃO');
                    }

                    if (this.bondConsultantCLT && !this.completedOffboardingForm)
                        return this.toastr.error('É obrigatório o preenchimento do formulário de Offboard do Portal Infra', 'ATENÇÃO')

                    if(this.bondConsultantCLT && this.consultant.contract.kind !== ContractType.PJ){//CLT
                        if(!this.consultant.consultantEnd)
                            return this.toastr.error('A data fim do consultor não foi preenchida.', 'Erro ao salvar o encerramento do consultor');

                        if(!this.consultant.contract.termination.end)
                            return this.toastr.error('A data do desligamento não foi preenchida.', 'Erro ao salvar o encerramento do consultor');
                    }

                    if (this.bondConsultantCLT && this.consultant.contract.kind !== ContractType.PJ) {
                        if(!this.consultant.consultantEnd)
                            return this.toastr.error('A data fim do consultor não foi preenchida.', 'Erro ao salvar o encerramento do consultor');
                    }

                    if (this.bondConsultantPJ && this.consultant.contract.kind === ContractType.PJ) {
                        if(!this.consultant.contract.end || !this.consultant.contract.termination.end)
                            return this.toastr.error('A data fim de contrato ou data fim do encerramento não foi preenchida.', 'Erro ao salvar o encerramento do consultor');
                    }

                    this.consultant.active = false;
                    if(this.consultant.newContract) {
                        this.consultant.active = true;
                        this.consultant.contract.termination.pendingDPApproval = false;
                        this.consultant.contract.termination.pendingGovApproval = false;
                    }
                }
            }

            //Verifica se houve aditivo (reajuste, renovação, alteração cnpj)
            if(this.newAdditiveIncluded) {
                this.additiveHistory.pendingApproval = true;
                if(this.user.permission != GUARDS.GOVERNANCE) {
                    this.additiveHistory.pendingGovApproval = true;
                }
                this.consultant.contract.additivesHistory.push(this.additiveHistory);
            }

            this.loading = true;
            let result = await this.consultantService.edit(this.consultant);
            if(this.redirect){
                this.loading = false;
                if(result._id) {
                    //Notificação e abertura de chamado à Infra somente se o encerramento do consultor for salvo com sucesso.
                    if(this.sendEmailInfra){
                        await this.notifyDepartament(5);
                        await this.createServiceTicket('offboarding');
                    }

                    if(this.sendEmailDepartments) {
                        await this.notifyDepartament(1);
                    }

                    if (this.newAdditiveIncluded) {
                        if( this.additiveHistory.hourValue != null && this.additiveHistory.additiveType == 1){
                            this.toastr.success("O aditivo foi cadastrado e está pendente de aprovação. Uma notificação foi enviada ao setor jurídico.", '', { timeOut: 9000 });
                            this.notifyDocumentPending(1);
                        } else if( this.additiveHistory.hourValue != null && this.additiveHistory.additiveType == 3){
                            this.toastr.success("A alteração de empresa foi cadastrada e está pendente de aprovação. Uma notificação foi enviada ao setor jurídico.", '', { timeOut: 9000 });
                            this.notifyDocumentPending(3);
                        }
                    }

                    //notificação para o jurídico sobre inclusão de empresa
                    if(this.consultant.contract.kind == 1 && this.withoutCompany && this.consultant.contract.companyName != '' && this.consultant.contract.companyName != null){
                        await this.consultantService.notifyDP(this.consultant, 10, 0);
                    }

                    this.router.navigate(['/consultants']);
                    this.toastr.success('Consultor atualizado com sucesso!');
                } else {
                    this.errorHandler.interceptError(result, 'Consultor');
                }
            } else {
                this.loading = false;
                this.redirect = true;
                return result;
            }
        } catch (err) {
            this.loading = false;
            this.errorHandler.interceptError(err, 'Consultor');
            if(this.redirect){
                this.router.navigate(['/consultants']);
            }
        }
    }

    async approveAdditiveByGov(i){
        try {
            let additiveAux: Additive = _.cloneDeep(this.consultant.contract.additivesHistory[i]);
            additiveAux.pendingGovApproval = false;

            this.additiveHistory = additiveAux;
            this.consultant.contract.additivesHistory.splice(i, 1);
            this.newAdditiveIncluded = true;

            await this.edit();
            this.closeModalAdditive.nativeElement.click();
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
            this.loading = false;
        }
    }

    async approveAdditive(i){
        try {
            this.toastr.warning('Preparando aditivo...');
            let additiveAux = new Additive();
            let history = new Additive();

            additiveAux = this.consultant.contract.additivesHistory[i];

            if(additiveAux.additiveType == 1){
                if(!this.validateDocumentGeneration('additiveValueAdjustment')) return;
            } else if(additiveAux.additiveType == 3) {
                if(!this.validateDocumentGeneration('additiveChangeCompany')) return;
            }

            history.additiveType = additiveAux.additiveType;
            history.date = additiveAux.date;
            history.honorarium = this.consultant.contract.honorarium;
            history.totalValue = this.consultant.contract.totalValue;
            history.totalCostWithBenefits = this.consultant.contract.totalCostWithBenefits;
            history.mensalHours = this.consultant.contract.mensalHours;
            history.soldHourValue = this.consultant.contract.soldHourValue;
            history.hourValue = this.consultant.contract.hourValue;
            history.hourValueBenefits = this.consultant.contract.hourValueBenefits;
            history.oldCompanyName = this.consultant.contract.companyName;
            history.oldCnpj = this.consultant.contract.cnpj;
            history.oldCompanyAddress = this.consultant.contract.address;
            history.oldCompanyNumber = this.consultant.contract.number;
            history.oldCompanyCep = this.consultant.contract.cep;
            history.oldCompanyCity = this.consultant.contract.city;
            history.oldCompanyDistrict = this.consultant.contract.district;
            history.oldCompanyState = this.consultant.contract.state;
            history.pendingApproval = false;

            this.consultant.contract.additivesHistory.splice(i, 1);

            if(additiveAux.additiveType == 1){
                this.consultant.contract.mensalHours = additiveAux.mensalHours;
                this.consultant.contract.soldHourValue = additiveAux.soldHourValue;
                this.consultant.contract.hourValue = additiveAux.hourValue;
                this.consultant.contract.hourValueBenefits = additiveAux.hourValueBenefits;
                this.consultant.contract.totalValue = additiveAux.totalValue;
                this.consultant.contract.totalCostWithBenefits = additiveAux.totalCostWithBenefits;
                this.consultant.contract.honorarium = additiveAux.honorarium;
            } else if(additiveAux.additiveType == 3){
                this.consultant.contract.companyName = additiveAux.oldCompanyName;
                this.consultant.contract.cnpj = additiveAux.oldCnpj;
                this.consultant.contract.address = additiveAux.oldCompanyAddress;
                this.consultant.contract.number = additiveAux.oldCompanyNumber;
                this.consultant.contract.cep = additiveAux.oldCompanyCep;
                this.consultant.contract.city = additiveAux.oldCompanyCity;
                this.consultant.contract.district = additiveAux.oldCompanyDistrict;
                this.consultant.contract.state = additiveAux.oldCompanyState;
                this.consultant.updateCNPJ = true;
            }

            this.consultant.contract.additivesHistory.push(history);
            this.redirect = false;

            let res = await this.edit();
            if(res._id){
                if(additiveAux.additiveType == 3){
                    additiveAux.oldCompanyName = history.oldCompanyName;
                    additiveAux.oldCnpj = history.oldCnpj;
                    additiveAux.oldCompanyAddress = history.oldCompanyAddress;
                    additiveAux.oldCompanyNumber = history.oldCompanyNumber;
                    additiveAux.oldCompanyCep = history.oldCompanyCep;
                    additiveAux.oldCompanyCity = history.oldCompanyCity;
                    additiveAux.oldCompanyDistrict = history.oldCompanyDistrict;
                    additiveAux.oldCompanyState = history.oldCompanyState;
                }
                this.loading = true;
                await this.generateAdditive(additiveAux);
                this.closeModalAdditive.nativeElement.click();
            } else {
                this.errorHandler.interceptError(res, 'Consultor');
            }
            this.loading = false;
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
            this.loading = false;
        }
    }

    async disapproveAdditive(i){
        this.consultant.contract.additivesHistory.splice(i, 1);
        await this.edit();
        this.closeModalAdditive.nativeElement.click();
    }

    async notifyDepartament(op){
        try {
            switch(op){
                case 1: // Departments for approval
                    await this.consultantService.notifyDP(this.consultant, op, 0);
                    this.toastr.success('Um e-mail foi enviado aos departamentos competentes para realizarem a aprovação do encerramento de vínculo');
                    break;
                case 2: // Responsavel divisão
                    if(this.optionLaptop == 2 || this.optionLaptop == 3 || this.optionLaptop == 4){
                        await this.consultantService.notifyDP(this.consultant, op, this.optionLaptop);
                        if(!this.consultant.contract.termination.returnAgreement){
                            this.toastr.success('Devolução de Laptop confirmada ou acordada');
                            this.toastr.success('Um e-mail foi enviado para o responsável pela divisão');
                        }
                    }
                    this.router.navigate(['/consultants']);
                    break;
                case 3: // Jurídico
                    await this.consultantService.notifyDP(this.consultant, op, 0);
                    this.toastr.success('Um e-mail foi enviado para o setor Jurídico');
                    break;
                case 5: // Infra
                    await this.consultantService.notifyDP(this.consultant, op, 0);
                    this.toastr.success('Um e-mail foi enviado para o setor de Infraestrutura');
                    break;
                default:
                    return false;
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    async notifyDocumentPending(type){
        await this.consultantService.notifyDP(this.consultant, 9, type);
    }

    verifyValidTouched(fieldName) {
        return !this.consultantForm.get(fieldName).valid;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    getVerboseField(name){
        return _.find(this.commonHelper.getConsultantVerboseFields(),{name:name});
    }

    changedContractType() {

        this.consultant.contract.mensalHours = 0;
        this.consultant.contract.soldHourValue = 0;
        this.consultant.contract.hourValue = 0;
        this.consultant.contract.hourValueBenefits = 0;
        this.consultant.contract.totalValue = 0;
        this.consultant.contract.totalCostWithBenefits = 0;

        this.consultant.contract.honorarium = 0;

        let kind = this.consultant.contract.kind;
        this.showSoldHoursValue = true;

        if (kind === ContractType.CLT) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValueBenefits(this.consultant);
            this.showTotalValue = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showSoldHoursValue = true;
            this.showHourValueBenefits = true;
            this.consultantForm.get('position').setValidators(null);
        }

        if (kind === ContractType.Intern || kind === ContractType.Others) {
            this.showTotalValue = true;
            this.showMensalHours = true;
            this.showHourValue = true;
            this.disableHourValue = false;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators(null);
        }

        if (kind === ContractType.PJ) {
            this.showTotalValue = false;
            this.showHourValue = false;
            this.showMensalHours = false;
            this.disableHourValue = false;
            this.showHourValueBenefits = false;
            this.consultantForm.get('position').setValidators([this.validateSelectOption]);
        }

        this.consultantForm.get('position').updateValueAndValidity({onlySelf: false, emitEvent: false});
    }

    addContract(){
        if (!this.consultant.contract.end)
            this.consultant.contract.end = moment(new Date()).format("DDMMYYYY");
        let contractHistory = Object.assign({}, this.consultant.contract);
        this.consultant.contractsHistory.push(contractHistory)

        this.consultant.contract = new Contract();
        this.additiveHistory = new Additive();
        if(!this.consultant.active){
            this.consultant.active = true;
        }

        this.consultant.newContract = true;
    }

    generateContractEnd() {
        if (!this.consultant.contract.end)
            this.consultant.contract.end = moment().utc().toISOString();
    }

    restoreContract(c){
        let newContract = new Contract();
        newContract = Object.assign(newContract, c);
        this.consultant.contract = newContract;
        this.consultant.contract.begin = '';//moment(this.consultant.contract.begin).format("DDMMYYYY");
        this.consultant.contract.end = '';//moment(this.consultant.contract.end).format("DDMMYYYY");
        this.consultant.contract.additivesHistory = [];
        this.consultant.contract.generated = false;
        this.consultant.contract.active = true;
        this.consultant.contract.termination = new TerminationContract();
        this.additiveHistory = new Additive();
        this.consultant.active = true;
        this.toastr.warning("Restaurando contrato...");
    }

    setAdditiveOption(op){
        this.validDateAdditive = false;
        this.additiveOption = op;
        if(!this.newAdditiveIncluded)
            this.additiveHistory.date = "";
    }

    changedHonorarium() {
        let honor = this.consultant.contract.honorarium;
        this.showSoldHoursValue = true;

        if (honor === HonorariumType.OpenHour) {
            this.showTotalValue = false;
            this.showHourValue = true;
            this.showMensalHours = false;
            this.disableHourValue = false;
            this.showHourValueBenefits = false;
        }

        if (honor === HonorariumType.ClosedHour) {
            this.consultant.contract.mensalHours = 168;
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValueBenefits(this.consultant);
            this.showTotalValue = true;
            this.showHourValue = true;
            this.disableHourValue = true;
            this.showMensalHours = true;
            this.showHourValueBenefits = false;
        }

    }

    changeBond(){
        if(!this.bondConsultantPJ || (this.consultant.active && this.bondConsultantCLT)){
            this.openModalInfra.nativeElement.click();
        }
    }

    closeModalBond(){
        this.consultant.active = true;
        this.bondConsultantPJ = false;
        this.bondConsultantCLT = false;
        this.sendEmailInfra = false;
        this.sendEmailDepartments = false;
        this.consultant.contract.termination.pendingGovApproval = false;
        this.consultant.contract.termination.pendingDPApproval = false;
    }

    notifyInfra() {
        this.sendEmailInfra = true;
    }

    notifyDepartmentsForApproval() {
        this.sendEmailDepartments = true;
    }

    startFillingConsultantTermination(){
        this.setApprovalFlag(this.user.permission);
        const now = new Date();
        let generated = this.consultant.contract.generated;
        if(generated){
            this.consultant.contract.termination.start = this.consultant.contract.begin;
            this.consultant.contract.termination.end = this.consultant.contract.end ? this.consultant.contract.end : moment(now).format("DDMMYYYY");
            if(!this.consultant.contract.end){
                this.consultant.contract.end = this.consultant.contract.termination.end
            }
            if(!this.consultant.consultantEnd){
                this.consultant.consultantEnd = this.consultant.contract.termination.end
            }
            if(this.consultant.contract.kind === ContractType.PJ) this.distractInProgress = true;
        } else{
            this.consultant.contract.termination.start = this.consultant.consultantStart;
            this.consultant.contract.termination.end = moment(now).format("DDMMYYYY");
            if(!this.consultant.consultantEnd){
                this.consultant.consultantEnd = this.consultant.contract.termination.end
            }
            if(!this.consultant.contract.end){
                this.consultant.contract.end = this.consultant.contract.termination.end
            }
            if(this.consultant.contract.kind === ContractType.PJ) this.dischargeInProgress = true;
        }
    }

    async generateContract(){
        try{
            if(!this.validateDocumentGeneration('contract'))
                return;

            if(this.consultant.contract.generated == false){
                // this.consultant.contract.generated = true;
                this.consultant.active = true;
                this.consultant.contract.contractStatus = 4;

                this.redirect = false;
                let res = await this.edit();
                if(res._id){
                    this.toastr.warning("Gerando contrato...");
                    this.loading = true;
                    let responseContract = await this.consultantService.generateContract(this.consultant);
                    if(responseContract.success) {
                        this.consultant.contract.generated = true;
                        this.toastr.success('Contrato gerado com sucesso!');
                        this.toastr.success('Consultor atualizado!');
                    } else {
                        this.errorHandler.interceptError(responseContract, 'Consultor');
                    }
                } else {
                    this.errorHandler.interceptError(res, 'Consultor');
                }
                this.loading = false;
            }
        } catch (err) {
            this.errorHandler.interceptError(err, 'Consultor');
            this.loading = false;
        }
    }

    async generateAdditive(additive){
        try{
            if(additive.additiveType == 1)
                this.toastr.warning("Gerando termo aditivo...");
            else if(additive.additiveType == 2)
                this.toastr.warning("Gerando renovação de contrato...");
            else if(additive.additiveType == 3)
                this.toastr.warning("Gerando alteração de dados...");

            this.loading = true;
            let responseAdditive = await this.consultantService.generateAdditive(this.consultant, additive);
            if(responseAdditive.success) {
                if(additive.additiveType == 1)
                    this.toastr.success("Termo aditivo gerado com sucesso");
                else if(additive.additiveType == 2) {
                    this.toastr.success("Renovação gerada com sucesso");
                    this.closeModalAdditive.nativeElement.click();
                }
                else if(additive.additiveType == 3)
                    this.toastr.success("Alteração gerada com sucesso");
            } else {
                this.errorHandler.interceptError(responseAdditive, 'Consultor');
            }
            this.loading = false;
        } catch (error) {
            this.errorHandler.interceptError(error, 'Consultor');
            this.loading = false;
        }
    }

    async generateIndividualAgreementHolidayTerm(){
        try {

            if(!this.validateDocumentGeneration('individualAgreementHoliday'))
                return;

            if(this.consultant.generatedIndividualAgreementHoliday == false) {
                this.toastr.warning("Gerando Acordo Individual...");
                let res = await this.consultantService.generateIndividualAgreementHolidayTerm(this.consultant);
                if(res.success) {
                    this.consultant.generatedIndividualAgreementHoliday = true;
                    this.toastr.success("Acordo Individual gerado com sucesso!");
                    this.toastr.success('Consultor atualizado!');
                } else {
                    this.errorHandler.interceptError(res, 'Consultor');
                }
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    async generateConfidentialityTerm() {
        try {
            if(!this.validateDocumentGeneration('confidentiality'))
                return;

            if(this.consultant.generatedConfidentiality == false){
                // this.consultant.generatedConfidentiality = true;
                this.toastr.warning("Gerando Termo de Confidencialidade...");
                this.redirect = true;
                let res = await this.consultantService.generateConfidentialityTerm(this.consultant);
                if(res.success) {
                    this.consultant.generatedConfidentiality = true;
                    this.toastr.success('Termo de confidencialidade gerado com sucesso!');
                    this.toastr.success('Consultor atualizado!');
                } else {
                    this.errorHandler.interceptError(res, 'Consultor');
                }
                this.redirect = false;
            }
        } catch (err) {
            this.errorHandler.interceptError(err, 'Consultor');
            this.redirect = false;
        }
    }

    async cepSearch(){
        let cep = this.consultant.personal.cep;
        cep = cep.replace(/\-/g, "");
        if(cep == '' || cep.length != 8){
            this.toastr.warning('CEP inválido');
        } else {
            this.toastr.warning('Realizando consulta ao CEP...');
            let response = await this.consultantService.getCep(cep);
            this.consultant.personal.address = response.logradouro;
            this.consultant.personal.district = response.bairro;
            this.consultant.personal.city = response.localidade;
            this.consultant.personal.state = response.uf;
        }
    }

    async cnpjSearch(){
        try {
            let cnpj = this.consultant.contract.cnpj;
            if(cnpj == '')
                return this.toastr.warning('CNPJ não pode ser vazio!');
            if(!this.consultantService.cnpjValid(cnpj))
                return this.toastr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');

            this.toastr.warning('Realizando consulta ao CNPJ...');
            cnpj = cnpj.trim();

            let response = await this.consultantService.getCnpj(cnpj, true);
            if(response.success) {
                if(response.isMei) {
                    this.consultant.contract.cnpj = '';
                    this.consultant.contract.companyName = '';
                    return this.toastr.warning(`O CNPJ ${cnpj} é do tipo MEI e não pode ser utilizado no sistema`, 'CNPJ Bloqueado');
                }

                this.consultant.contract.companyName = response.nome;
                this.consultant.contract.address = response.logradouro;
                this.consultant.contract.number = response.numero;
                this.consultant.contract.complement = response.complemento;
                this.consultant.contract.cep = response.cep;
                this.consultant.contract.district = response.bairro;
                this.consultant.contract.city = response.municipio;
                this.consultant.contract.state = response.uf;
            } else {
                return this.errorHandler.interceptError(response, 'Consultor');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Empresa');
        }
    }

    async finishBond(){
        try{
            if(this.consultant.contract.generated){
                if(!this.validateDocumentGeneration(this.typeGenerateDissolutionDischarge(this.optionDistract))) return;
            } else {
                if(!this.validateDocumentGeneration('discharge')) return;
            }

            this.redirect = false;
            // this.consultant.contract.termination.documentGenerated = true;
            if(this.consultant.contract.generated){
                this.consultant.contract.termination.type = this.optionDistract;
                this.consultant.contract.end = this.consultant.contract.termination.end;
            } else {
                this.consultant.contract.termination.type = 1;
                this.consultant.consultantEnd = this.consultant.contract.termination.end;
            }

            this.consultant.contract.termination.generationDate = moment(new Date()).format("DDMMYYYY");

            let res = await this.edit();
            if(res._id){
                let responseDocument;
                this.loading = true;
                if(this.consultant.contract.generated){
                    this.toastr.warning("Gerando distrato...");
                    responseDocument = await this.consultantService.generateDistract(this.consultant);
                } else {
                    this.toastr.warning("Gerando termo de quitação...");
                    responseDocument = await this.consultantService.generateDischarge(this.consultant);
                }

                if(responseDocument.success) {
                    this.distractGenerated = true;
                    this.consultant.contract.termination.documentGenerated = true;
                    this.toastr.success(`${this.consultant.contract.generated ? 'Distrato' : 'Termo de Quitação'} gerado com sucesso`);
                    this.toastr.success('Consultor atualizado!');
                    window.location.reload();
                } else {
                    this.errorHandler.interceptError(responseDocument, 'Consultor');
                }
            } else {
                this.errorHandler.interceptError(res, 'Consultor');
            }
            this.loading = false;
        } catch (error) {
            this.errorHandler.interceptError(error, 'Consultor');
            this.loading = false;
            this.router.navigate(['/consultants']);
        }
    }

    calculateHourValue() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.ClosedHour)) {
            this.consultant.contract.hourValue = this.consultantService.calculateHourValue(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    calculateHourValueBenefits() {
        let kind = this.consultant.contract.kind;
        let honor = this.consultant.contract.honorarium;

        if (kind === ContractType.CLT
            || (kind === ContractType.PJ && honor === HonorariumType.ClosedHour)) {
            this.consultant.contract.hourValueBenefits = this.consultantService.calculateHourValueBenefits(this.consultant);
            this.disableHourValue = true;
        } else {
            this.disableHourValue = false;
        }
    }

    async verifyEmail(){
        this.trim('fcEmail');
        this.trim('email');
        if(!this.consultant.fcEmail)
            return this.toastr.warning("E-mail Nação Digital é obrigatório.");
        if(!this.consultant.personal.cpf)
            return this.toastr.warning("CPF é obrigatório");

        const response = await this.publicConsultantService.verifyIfEmailExists(this.consultant.fcEmail);
        if(response.error) {
            this.toastr.error(response.error.message);
            this.consultant.fcEmail = "";
        } else if(response.emailExists) {
            this.toastr.warning(`E-mail FC ${this.consultant.fcEmail} já está em uso!`);
            this.consultant.fcEmail = "";
        }
    }

    async verifyCPF(){
        const clearCpf = () => {
            this.consultant.personal.cpf = "";
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
        }

        try {
            const cpf = this.consultant.personal.cpf;
            if(cpf == null || cpf == ""){
                clearCpf();
                return this.toastr.warning("O CPF é obrigatório!");
            }

            if(!(this.commonHelper.cpfValidator(cpf))){
                clearCpf();
                return this.toastr.warning("CPF inválido");
            }

            let responseCpfExists = await this.consultantService.verifyCPF(this.consultant);
            if(responseCpfExists.length > 0 && responseCpfExists[0]._id != this.consultant._id){
                clearCpf();
                return this.toastr.warning(`Este CPF é utilizado pelo consultor: ${responseCpfExists[0].name}`,"CPF já está em uso!");
            }

            let responseFreshService = await this.consultantService.getFreshServiceEmailByCPF(cpf);
            if(responseFreshService && responseFreshService.fcEmail) {
                this.consultant.fcEmail = responseFreshService.fcEmail;
                this.consultant.freshServiceId = responseFreshService.freshServiceId;
                this.verifyEmail();
            } else {
                this.errorHandler.interceptError(responseFreshService, 'Consultor');
            }
            this.disableFcEmail();
        } catch(err) {
            this.consultant.fcEmail = "";
            this.consultant.freshServiceId = "";
            this.disableFcEmail();
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    disableFcEmail(){
        const control = this.consultantForm.get('fcEmail');
        if(!this.consultant.personal.cpf)
            control.disable();
        else
            control.enable();
    }

    async verifyCPFCNPJPixKey(){
        if(!this.consultant.payment.keyPix){
            this.toastr.warning("O CPF/CNPJ é obrigatório!");
            this.consultant.payment.keyPix = "";
        } else if(this.commonHelper.cpfValidator(this.consultant.payment.keyPix)){
            this.pixCpfValid = true;
        } else if(this.companiesService.cnpjValid(this.consultant.payment.keyPix)){
          this.pixCnpjValid = true;
        }else if(!this.pixCnpjValid && !this.pixCpfValid){
          this.toastr.warning('CPF/CNPJ inválido.');
          this.consultant.payment.keyPix = "";
        }
    }

    cnpjValid(cnpj: String) {
        return this.consultantService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.consultantService.getCnpj(cnpj);
    }

    randomPixKeySearch(){
        if(!this.consultant.payment.keyPix) {
            this.toastr.warning('Aleatória não pode ser vazio');
        } else if (!this.consultantService.randomPixKeyValid(this.consultant.payment.keyPix)) {
            this.toastr.warning('Aleatória inválida. Aleatória deve ter 36 caracteres!');
            this.consultant.payment.keyPix = '';
        }
    }

    async verifyEmailPixKey(){
        this.trimPixKey();
        if(!this.consultant.payment.keyPix){
         this.toastr.warning("O Email é obrigatório!");
        }else{
            if (!(new RegExp(this.emailPattern).test((this.consultant.payment.keyPix).toString()))) {
                this.toastr.warning(`Digite um email válido.`, "Email inválido!");
                this.consultant.payment.keyPix = "";
            }
        }
    }

    changeSkill(){
        if(this.consultant.skills.length <= this.skillsDropdown.selected.length){
            let diff = _.differenceWith(this.skillsDropdown.selected, this.consultant.skills, (a,b)=> a.id == b._id )
            this.consultant.skills.push({
                _id:diff[0].id,
                name:diff[0].itemName
            })
        }
        else {
            let diff = _.differenceWith(this.consultant.skills,this.skillsDropdown.selected, (a,b)=> a._id == b.id )
            _.remove(this.consultant.skills, item => item._id == diff[0]._id)
        }
    }

    async getS3Files(){
        this.fileList = await this.awsService.getFiles(this.consultant._id);
    };

    async getS3FilesConsultantTermination(id:string) {
        const file = await this.awsService.getFiles(`consultant-termination/${id}`);
        this.fileList.push(...file);
    };

    selectFile(event) {
        this.selectedFiles = event.target.files;
    }

    async deleteFile(name){
        await this.awsService.deleteFile(name);
        await this.getS3Files();
    }

    async upload(uploadType?: string) {
        try {
            let id = this.consultant._id;
            let length = this.selectedFiles.length;
            for(let i=0; i<length; i++){
                const file = this.selectedFiles.item(i);
                if (uploadType) {
                    await this.awsService.uploadfile(file,`${uploadType}/${id}`);
                } else {
                    await this.awsService.uploadfile(file,id);
                }
            }

            if (!uploadType) {
                await this.getS3Files();
            }
        } catch (error) {
            console.log(error);
        }
    }
    async download(name){
        this.downloadUrl = await this.awsService.download(name);
    }

    verifyDate(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
        }
    }
    verifyDate2(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${field}`] = "";
        }
    }
    verifyDate3(date,doc,doc2,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${doc2}`][`${field}`] = "";
        }
    }
    verifyDate4(date,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.additiveHistory[`${field}`] = "";
            this.validDateAdditive = false;
        } else {
            this.validDateAdditive = true;
        }
    }

    verifyNameMask(rawValue: string): RegExp[] {
        const mask = /[A-Za-zÁ-Úá-úÀ-Ùà-ùÃ-Õã-õÄ-Üä-üÂ-Ûâ-ûÇç' ']/;
        const strLength = String(rawValue).length;
        const nameMask: RegExp[] = [];
        for (let i = 0; i <= strLength; i++) {
          nameMask.push(mask);
        }
        return nameMask
    }

    verifyDateContractStart(date,doc,field){
        if(!(new RegExp(this.datePattern).test(date))){
            this.toastr.warning(`Digite uma data válida.`,"Data inválida!");
            this.consultant[`${doc}`][`${field}`] = "";
            this.consultant[`${doc}`][`end`] = "";
        } else {
            // let dateAux = moment(this.consultant.contract.begin, "DD/MM/YYYY").add(9,'months');
            // this.consultant.contract.end = moment(dateAux).format("DDMMYYYY");
        }
    }

    changeCnae(){
        this.consultant.contract.sapServiceCode = this.cnaes.find(x => x.cnae === this.consultant.contract.cnae).sapItemCode;
    }

    async loggedUserValidation(){
        if(this.user.permission == GUARDS.RS) {
            let allUsers = await this.userService.getAllUsers();
            allUsers = allUsers.map(user => user.username.toLowerCase());
            const consultantIsUser = allUsers.find(u => u === this.consultant.fcEmail.toLowerCase());
            if(consultantIsUser)
                this.blockLoggedUser = true;
        }
    }

    clearSkill() {
        this.skillAux = '';
    }

    async addSkill() {
        try {
            let resp = await this.consultantService.createSkill(this.skillAux.toUpperCase());
            if(resp._id){
                this.skillsDropdown.list = [
                    ...this.skillsDropdown.list,
                    { id: resp._id, itemName: resp.name }
                ]
                this.toastr.success('Skill criada com sucesso');
            } else {
                this.errorHandler.interceptError(resp, 'Consultor');
            }
            this.clearSkill();
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    openAddModalBank(){
        this.bankCode = null
        this.bankName = ""
        this.bankCountry = ""
    }

    async addBank(){
        try {
            const response = await this.bankService.postBank({
                name: this.bankName,
                countryCode: this.bankCountry,
                bankCode: this.bankCode
            });

            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco criado com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Consultor');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    openEditBank(bank:any){
        this.bankCode = bank.bankCode;
        this.bankName = bank.name;
        this.bankCountry = bank.countryCode;
        this.bankSapCode = bank.sapCode;
        this.bank_id =  bank._id;
    }

    async editBank(){
        try {
            let bankEdit = {
                "active": true,
                "bankCode": this.bankCode,
                "name": this.bankName,
                "countryCode": this.bankCountry.toUpperCase(),
                "sapCode": this.bankSapCode,
                "_id": this.bank_id
            }

            const response = await this.bankService.updateBank(bankEdit);
            if(response._id) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco atualizado com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Consultor');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    openDeleteBank(bank:any){
        this.bankCode = bank.bankCode;
    }

    async removeBank() {
        try {
            const response = await this.bankService.removeBank(this.bankCode);
            if(response.success) {
                this.banks = await this.bankService.getBanks();
                this.toastr.success('Banco excluído com sucesso');
            } else {
                this.errorHandler.interceptError(response, 'Banco');
            }
        } catch(err) {
            this.errorHandler.interceptError(err, 'Consultor');
        }
    }

    addCustomer() {
        const customers = [...this.consultant.contract.customers];
        this.consultant.contract.customers = [
            ...customers, {
                _id: '', name: '', start: null, end: null, managerClient: ''
            }
        ];
    }

    removeCustomer(i) {
        this.consultant.contract.customers.splice(i, 1);
    }

    loadCustomersList(){
        if (this.customersLoaded.length <= 0) {
            this.customersLoaded = this.customers
        }
    }

    onCustomerChange(customersId, i){
        this.consultant.contract.customers[i]._id = customersId
        this.consultant.contract.customers[i].name =  this.customersLoaded.find(cl => cl._id == customersId).name
    }

    removeCustomersList(){
        this.customersLoaded = []
    }

    documentsInProgressIncomplete() {
        const isValueFilled = Number(this.consultant.contract.termination.value) >= 0;

        //BP não preenche o campo de valor, apenas os demais usuários
        const isValueFieldValid = this.isUserBp || (!this.isUserBp && isValueFilled);

        if(this.additiveValueAdjustmentInProgress) {
            if(Number(this.consultant.contract.honorarium) == 0 ||
                (this.consultant.contract.honorarium == 1 && !this.consultant.contract.hourValue) ||
                (this.consultant.contract.honorarium == 2 && !this.consultant.contract.totalValue)){
                this.toastr.error('Há campos obrigatórios que não foram preenchidos no formulário', 'Erro ao salvar reajuste de valor'); return true;
            };
        } else if(this.additiveChangeCompanyInProgress) {
            if(this.contractInvalid(_.cloneDeep(this.consultant))){
                this.toastr.error('Há campos obrigatórios que não foram preenchidos no formulário', 'Erro ao salvar alteração de empresa'); return true;
            };
        } else if(this.distractInProgress) {
            if(!isValueFieldValid ||
                !this.consultant.contract.termination.start || !this.consultant.contract.termination.end ||
                !this.consultant.contract.end){
                this.toastr.error('Há campos obrigatórios que não foram preenchidos no formulário. Verifique a data fim de contrato e os campos de encerramento.', 'Erro ao salvar distrato'); return true;
            };
            this.consultant.contract.end = this.consultant.contract.termination.end;
        } else if(this.dischargeInProgress) {
            if(!isValueFieldValid ||
                (!this.consultant.contract.termination.qtdHours && Number(this.consultant.contract.termination.qtdHours) != 0) ||
                !this.consultant.contract.termination.start || !this.consultant.contract.termination.end ||
                !this.consultant.consultantEnd){
                this.toastr.error('Há campos obrigatórios que não foram preenchidos no formulário. Verifique a data fim do consultor e os campos de encerramento.', 'Erro ao salvar termo de quitação'); return true;
            };
            this.consultant.consultantEnd = this.consultant.contract.termination.end;
        };

        return false;
    }

    validateDocumentGeneration(type: string) {
        const consultantData = this.startedBorrowedNote ? this.lenderConsultant : this.consultant;
        let documentTypes = {
            'contract': {
                'invalid': this.contractInvalid(consultantData) || this.consultantPersonalInvalid(consultantData) ||
                    (this.consultant.contract.honorarium == 1 && !this.consultant.contract.hourValue) ||
                    (this.consultant.contract.honorarium == 2 && !this.consultant.contract.totalValue) ||
                    Number(this.consultant.contract.position) == 0,
                'group': ['personal','contract']
            },
            'discharge': {
                'invalid': this.consultantPersonalInvalid(consultantData) || !this.consultant.consultantEnd ||
                    (!this.consultant.contract.termination.qtdHours && this.consultant.contract.termination.qtdHours != 0) ||
                    (!this.consultant.contract.termination.value && this.consultant.contract.termination.value != 0),
                'group': ['personal']
            },
            'distractMutualAgreement': {
                'invalid': this.contractInvalid(consultantData) || this.consultantPersonalInvalid(consultantData) ||
                    !this.consultant.contract.end,
                'group': ['personal','contract']
            },
            'distractByTheContractor': {
                'invalid': this.contractInvalid(consultantData) || this.consultantPersonalInvalid(consultantData) ||
                    !this.consultant.contract.end,
                'group': ['personal','contract']
            },
            'additiveValueAdjustment': {
                'invalid': this.contractInvalid(consultantData) || this.consultantPersonalInvalid(consultantData),
                'group': ['personal','contract']
            },
            'additiveRenovation': {
                'invalid': this.contractInvalid(consultantData) || this.consultantPersonalInvalid(consultantData),
                'group': ['personal','contract']
            },
            'additiveChangeCompany': {
                'invalid': this.contractInvalid(consultantData),
                'group': ['contract']
            },
            'confidentiality': {
                'invalid': this.consultantPersonalInvalid(consultantData),
                'group': ['personal']
            },
            'individualAgreementHoliday': {
                'invalid': this.consultantPersonalInvalid(consultantData) || !this.consultant.contract.begin,
                'group': ['personal']
            },
        };

        if(documentTypes[type].invalid) {
            let personalData = this.personalDataInvalid && documentTypes[type].group.includes('personal') ?
                '\n•Dados pessoais: Nome, RG, CPF, dados de endereço e estado civil.' : '';
            let contractData = this.contractDataInvalid && documentTypes[type].group.includes('contract') ?
                '\n•Dados de contrato: CNPJ, razão social, fim de contrato e dados de endereço empresa.' : '';
            this.toastr.error(`Há dados obrigatórios no documento Clicksign que não foram preenchidos no consultor.\n${personalData}\n${contractData}`, 'Formulário incompleto');
            return false;
        };
        return true;
    };

    contractInvalid(consultant: Consultant): boolean {
        let contractDataInvalid = !consultant.contract.cnpj ||
            !consultant.contract.companyName ||
            !consultant.contract.address ||
            !consultant.contract.number ||
            !consultant.contract.cep ||
            !consultant.contract.city ||
            !consultant.contract.state ||
            consultant.contract.state == '0';
        this.contractDataInvalid = contractDataInvalid;
        return contractDataInvalid;
    };

    consultantPersonalInvalid(consultant: Consultant): boolean {
        let personalDataInvalid = !consultant.name ||
            !consultant.personal.rg ||
            !consultant.personal.cpf ||
            !consultant.personal.address ||
            !consultant.personal.number ||
            !consultant.personal.cep ||
            !consultant.personal.city ||
            !consultant.personal.country ||
            consultant.personal.country == '0' ||
            (consultant.personal.country == "Brasil" && (!consultant.personal.state || consultant.personal.state == '0')) ||
            Number(consultant.personal.civilStatus) == 0;
        this.personalDataInvalid = personalDataInvalid;
        return personalDataInvalid;
    };

    borrowedNoteInProgress(): void {
        this.borrowInvoiceNoteInProgress = true;
    }

    async setStartedBorrowedNote(): Promise<void> {
        this.startedBorrowedNote = true;
        this.activeBorrowedInvoiceNote = true;
        let borrowedInvoiceNoteLenderData = await this.consultantService.getById(this.consultant.borrowInvoiceNote.lenderId);
        this.lenderConsultant.loadConsultantFromServer(borrowedInvoiceNoteLenderData);
    };

    async openModalContract(typeContract, typeAdtive?) {
        if (this.borrowInvoiceNoteInProgress) await this.setStartedBorrowedNote();
        if (this.consultant["lender"]) delete this.consultant["lender"];

        if (typeContract == 'contract') {
            this.isBorrowedDeclaration = false;
        } else if (typeContract == 'borrowedNoteDeclaration') {
            this.isBorrowedDeclaration = true;
            this.startedBorrowedNote = false;
        };
        this.reloadDocModal = !this.reloadDocModal;
        this.typeContractModal = typeContract;
        this.typeAdtiveModal = typeAdtive;
        const isContractNote = this.lenderConsultant && this.startedBorrowedNote && !this.isBorrowedDeclaration;
        const isDeclarationNote = this.isBorrowedDeclaration;
        if (isContractNote) {
            const lenderConsultant = {...this.lenderConsultant} as Consultant;
            if (this.validateLenderData(lenderConsultant)) {
                this.startedBorrowedNote = false;
                this.borrowInvoiceNoteInProgress = false;
                this.toastr.warning(`Há dados obrigatórios para o documento Clicksign que não existem nos dados do 'Emprestador', por favor
                atualize os dados do 'Emprestador' para prosseguir com a geração de documento.`, 'Formulário incompleto', {TimeOut: 6000});
                return;
            } else {
                this.lenderConsultant["isBorrowedNoteLender"] = true;
                this.lenderConsultant["borrowNoteData"] = {...this.consultant.borrowInvoiceNote};
                this.buttonOpenModalContract.nativeElement.click();
                return;
            };
        };

        if (isDeclarationNote) {
            if (this.validateDeclarationFields(this.consultant)) {
                this.borrowInvoiceNoteInProgress = false;
                this.toastr.warning(`Há dados obrigatórios para o documento Clicksign que não foram preenchidos,
                 por favor verifique se os valores de contrato foram preenchidos corretamente. \n•Dados de contrato: Honorário, Cargo, Valor total e valor de custo por hora.`,
                 'Formulário incompleto', {TimeOut: 6000});
                return;
            } else {
                this.consultant["lender"] = this.lenderConsultant;
                this.buttonOpenModalContract.nativeElement.click();
                return;
            };
        };

        if(!this.validateDocumentGeneration(this.typeContractModal))
            return;
        else
            this.buttonOpenModalContract.nativeElement.click();
    };

    validateDeclarationFields(consultant: Consultant): boolean {
        let validateConsultant = {...consultant} as Consultant;
        let contractValuesInvalid = Number(validateConsultant.contract.honorarium) == 0 ||
        (validateConsultant.contract.honorarium == HonorariumType.OpenHour && !validateConsultant.contract.hourValue) ||
        (validateConsultant.contract.honorarium == HonorariumType.ClosedHour && !this.consultant.contract.totalValue) ||
        Number(validateConsultant.contract.position) == 0;
        return contractValuesInvalid;
    };

    validateLenderData(lender: Consultant | null): boolean {
        if (lender === null) return false;

        const lenderConsultant = {...lender} as Consultant;
        let lenderInvalid = this.contractInvalid(lenderConsultant) || this.consultantPersonalInvalid(lenderConsultant) ||
            (lenderConsultant.contract.honorarium == HonorariumType.OpenHour && !lenderConsultant.contract.hourValue) ||
            (lenderConsultant.contract.honorarium == HonorariumType.ClosedHour && !this.consultant.contract.totalValue) ||
            Number(lenderConsultant.contract.position) == 0;
        return lenderInvalid;
    };

    async getConsultantData(event: any): Promise<void> {
        if (this.startedBorrowedNote) {
            this.verifyDocumentTypeAndGenerate('borrowedNoteContract', this.typeAdtiveModal);
        } else {
            this.consultant = event;
            this.verifyDocumentTypeAndGenerate(this.typeContractModal, this.typeAdtiveModal);
        }
    }

    async verifyDocumentTypeAndGenerate(docType: String, additive?: any): Promise<void> {
        this.toastr.warning("Carregando...");
        switch(docType) {
            case 'contract':
                await this.generateContract();
                break;
            case 'borrowedNoteContract':
                await this.generateBorrowedContractNote();
                break;
            case 'borrowedNoteDeclaration':
                await this.generateBorrowedDeclarationNote();
                break;
            case 'discharge':
            case 'distractMutualAgreement':
            case 'distractByTheContractor':
                await this.finishBond();
                break;
            case 'additiveValueAdjustment':
            case 'additiveChangeCompany':
                await this.approveAdditive(additive);
                break;
            case 'additiveRenovation':
                this.redirect = false;
                let res = await this.edit();
                if(res._id){
                    await this.generateAdditive(this.consultant.contract.additivesHistory[this.typeAdtiveModal]);
                    this.router.navigate(['/consultants']);
                }
                break;
            case 'confidentiality':
                await this.generateConfidentialityTerm();
                 break;
            default:
                this.toastr.error('Erro ao tentar gerar um documento.', '', {timeout: 3000})
                break;
        }
    }

    typeGenerateDissolutionDischarge(type) {
        switch (type) {
            case 2: return 'distractMutualAgreement';
            case 3: return 'distractByTheContractor';
            default: return '';
        }
    }

    onPixTypeChange() {
        this.pixValidation.onPixTypeChange(this.consultant.payment.typePix, this.consultantForm.get("keyPix"))
        this.textMask = {mask: false}
    }

    async verifyPixKey(){
        if (!this.consultant.payment.typePix) {
            return
        }
        this.pixCpfValid = false;
        this.pixCnpjValid = false;

        let typePix = this.consultant.payment.typePix

        switch (typePix) {
            case PixKeyType.phone:
                if(!this.commonHelper.phoneNumberValidator(this.consultant.payment.keyPix)){
                    this.toastr.warning('CPF/CNPJ inválido.');
                    this.consultant.payment.keyPix = "";
                }
                break;
            case PixKeyType.email:
                this.verifyEmailPixKey();
                break;
            case PixKeyType.cpf_cnpj:
                this.verifyCPFCNPJPixKey();
                break;
            case PixKeyType.randomized:
                this.randomPixKeySearch();
                break;
            default:
                break;
        }
    }

    onChangeMask() {
        let typePix = this.consultant.payment.typePix;
        switch (typePix) {
            case PixKeyType.phone:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
                break;
            case PixKeyType.cpf_cnpj:
                let inputValue = this.consultant.payment.keyPix;
                if(!inputValue) return;

                if (inputValue && inputValue.length > 14)
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
                else
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
                break;
            case PixKeyType.randomized:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
                break;
            default:
                break;
        }
    }

    disableState() {
        if(this.consultant.personal.country == 'Brasil' ||
           this.consultant.personal.country == '0') {
            this.consultantForm.get('state').enable();
        } else {
            this.consultantForm.get('state').disable();
            this.consultant.personal.state = '0';
        }
    }

    handleModalPdf(isOpen: boolean): void {
        if (isOpen) {
            this.startedBorrowedNote = !isOpen;
            this.isBorrowedDeclaration = !isOpen;
            this.borrowInvoiceNoteInProgress = !isOpen
        }
    };

    async generateBorrowedContractNote(): Promise<void> {
        try{
            if(this.consultant.borrowInvoiceNote.contract.generated == false) {
                this.toastr.warning("Gerando contrato de nota emprestada...");
                this.lenderConsultant['lender'] = true;
                this.lenderConsultant['borrowedConsultantId'] = this.consultant._id;
                this.lenderConsultant.contract.begin = moment(this.consultant.borrowInvoiceNote.start).format("DDMMYYYY");
                this.startedBorrowedNote = false;
                this.borrowInvoiceNoteInProgress = false;
                let responseContract = await this.consultantService.generateContract(this.lenderConsultant);
                if(responseContract.success) {
                    this.consultant.borrowInvoiceNote.contract.generated = true;
                    this.toastr.success('Contrato de nota emprestada gerado com sucesso!');
                    this.toastr.success('Consultor atualizado!');
                } else {
                    this.errorHandler.interceptError(responseContract, 'Consultor');
                }
            };
        } catch (err) {
            this.errorHandler.interceptError(err, 'Consultor');
        };
    };

    async generateBorrowedDeclarationNote(): Promise<void> {
        try{
            if(this.consultant.borrowInvoiceNote.declaration.generated == false) {
                this.toastr.warning("Gerando declaração de nota emprestada...");
                let responseContract = await this.consultantService.generateBorrowedInvoiceDeclarationNote(this.consultant);
                if(responseContract.success) {
                    this.consultant.borrowInvoiceNote.declaration.generated = true;
                    this.borrowInvoiceNoteInProgress = false;
                    this.isBorrowedDeclaration = false;
                    this.toastr.success('Declaração de nota emprestada gerado com sucesso!');
                    this.toastr.success('Consultor atualizado!');
                } else {
                    this.errorHandler.interceptError(responseContract, 'Consultor');
                }
            };
        } catch (err) {
            this.errorHandler.interceptError(err, 'Consultor');
        };
    };

    async changeBorrowNote(): Promise<void> {
        if(this.activeBorrowedInvoiceNote) {
            this.buttonOpenModalBorrowNote.nativeElement.click();
            let consultantsPJ = await this.consultantService.listAll();
            this.consultantsBorrowInvoice = consultantsPJ.filter(c => {
                return c.sapCardCode != '' && c.contract && c.contract.kind == 1 && c.contract.cnpj != '' && c.contract.sapServiceCode != ''
            });
        };
    };

    async getBorrowedNoteData(lenderData: BorrowedNote): Promise<Toast> {
        const receivedData = { ...lenderData };
        if (receivedData.lenderId) {
            this.consultant.borrowInvoiceNote.loadData(receivedData);
        }else {
            this.activeBorrowedInvoiceNote = false;
            return this.toastr.warning(`Preencha os dados em 'Empréstimo de Nota Fiscal' para prosseguir com
                a geração dos Contrato e Declaração de Nota Emprestada`, 'Nota Emprestada', {TimeOut: 6000});
        };
    };

    checkSupportCenter(supportId){
        if(supportId !== undefined && supportId !== null) {
            return this.supportCenters.find(cs => cs._id == supportId);
        }
        return null
    }

    async getConsultantSelfFill() {
        this.consultantSelfFill = await this.consultantService.getConsultantSelfFill(this.consultantId);
        this.consultantSelfFill.forEach((_, index) => {
            this.consultantSelfFill[index].canEdit = this.consultantSelfFill[index].approvedStatus == SelfFillRequestStatus.Pending
        })
    }

    changesToUpdateApproved(selfFill, id, i) {
        this.updateApprovedConsuntant = selfFill;
        this.idToUpdateApproved = id;
        this.indexToUpdateApproved = i;
    }

    async updateConsuntantAutoFills() {
        if(this.updateApprovedConsuntant && this.updateApprovedConsuntant.updatedData) {
            if(this.updateApprovedConsuntant.updatedData.emergency) {
                let emergency = this.updateApprovedConsuntant.updatedData.emergency;
                this.consultant.emergency.type = emergency.type ? emergency.type : this.consultant.emergency.type;
                this.consultant.emergency.name = emergency.name ? emergency.name : this.consultant.emergency.name;
                this.consultant.emergency.phone = emergency.phone ? emergency.phone : this.consultant.emergency.phone;
            }

            if(this.updateApprovedConsuntant.updatedData.personal) {
                let personal = this.updateApprovedConsuntant.updatedData.personal;
                this.consultant.personal.rg = personal.rg ? personal.rg : this.consultant.personal.rg;
                this.consultant.personal.cpf = personal.cpf ? personal.cpf : this.consultant.personal.cpf;
                this.consultant.personal.born = personal.born ? moment(personal.born).format("DDMMYYYY") : this.consultant.personal.born;
                this.consultant.personal.sex = personal.sex ? personal.sex : this.consultant.personal.sex;
                this.consultant.personal.civilStatus = personal.civilStatus ? personal.civilStatus : this.consultant.personal.civilStatus;
                this.consultant.personal.motherName = personal.motherName ? personal.motherName : this.consultant.personal.motherName;
                this.consultant.personal.fatherName = personal.fatherName ? personal.fatherName : this.consultant.personal.fatherName;
                this.consultant.personal.homePhone = personal.homePhone ? personal.homePhone : this.consultant.personal.homePhone;
                this.consultant.personal.cellPhone = personal.cellPhone ? personal.cellPhone : this.consultant.personal.cellPhone;
                this.consultant.personal.cep = personal.cep ? personal.cep : this.consultant.personal.cep;
                this.consultant.personal.address = personal.address ? personal.address : this.consultant.personal.address;
                this.consultant.personal.number = personal.number ? personal.number : this.consultant.personal.number;
                this.consultant.personal.complement = personal.complement ? personal.complement : this.consultant.personal.complement;
                this.consultant.personal.district = personal.district ? personal.district : this.consultant.personal.district;
                this.consultant.personal.city = personal.city ? personal.city : this.consultant.personal.city;
                this.consultant.personal.country = personal.country ? personal.country : this.consultant.personal.country;
                this.consultant.personal.state = personal.state ? personal.state : this.consultant.personal.state;
            }

            if(this.updateApprovedConsuntant.updatedData.email)
                this.consultant.email = this.updateApprovedConsuntant.updatedData.email;

            if(this.updateApprovedConsuntant.updatedData.name)
                this.consultant.name = this.updateApprovedConsuntant.updatedData.name;

            this.redirect = false;
            return await this.edit();
        }
    }

    async updateApproved() {
        let resConsuntant = await this.updateConsuntantAutoFills();
        if(resConsuntant._id) {
            this.consultant = await this.consultantService.getById(this.consultantId);
            const res = await this.consultantService.updateApproved(this.idToUpdateApproved);
            if(res && res.approvedStatus) {
                this.consultantSelfFill[this.indexToUpdateApproved] = res;
                this.toastr.success('Consultor atualizado com sucesso!');
                if(this.redirect){
                    this.router.navigate(['/consultants']);
                }
            }
        }
    }

    async updateReproved() {
        const res = await this.consultantService.updateReproved(this.idToUpdateApproved);
        if(res && res.approvedStatus) {
            this.consultantSelfFill[this.indexToUpdateApproved] = res
            this.toastr.success('Atualização reprovado com sucesso!');
        }
    }

    convertDate(date) {
        return moment(date).format('L');
    }

    openModalCompareData(selfFill) {
        this.selfFillData = selfFill;
    }

    userCanApproveSelfFill() {
        if(this.user.permission == this.GUARDS.GOVERNANCE && this.consultant.contract.kind == 1)
            return true;
        if(this.user.permission == this.GUARDS.DP && this.consultant.contract.kind == 2)
            return true;
        return false;
    }

    setSupportCenterValidator() {
        const mustHaveSupportCenter = '61d332a846958f43022290af'
        if(this.consultant.excellenceCenter && this.consultant.excellenceCenter._id) {
            if (this.consultant.excellenceCenter._id.includes(mustHaveSupportCenter)) {
                this.consultantForm.get('supportCenter').setValidators(Validators.required);
                this.hasRequiredExcellenceCenter = true;
            } else {
                this.hasRequiredExcellenceCenter = false;
                this.consultantForm.get('supportCenter').clearValidators();
            }
        }
        this.consultantForm.get('supportCenter').updateValueAndValidity();
    }

    cancelNewAdditive() {
        this.validDateAdditive = false;
        this.additiveOption = 0;
        this.additiveHistory = new Additive();
        this.additiveHistory.date = "";
        this.newAdditiveIncluded = false;

        this.showBtnNewAdditiveReadjustment = true;
        this.showBtnNewAdditiveRenew = true;
        this.showBtnNewAdditiveChangeCompany = true;

        this.toastr.warning('Novo aditivo cancelado');
    }

    async getAdditiveData(event: any): Promise<void> {
        this.additiveHistory = event;
        //Criação de aditivo pela BP
        if(this.user.permission != GUARDS.GOVERNANCE) {
            this.additiveHistory.pendingGovApproval = true;
            if (this.additiveOption == 2) {
                this.additiveHistory.pendingGovApproval = false;
            }
            this.consultant.contract.additivesHistory.push(this.additiveHistory);
            const FINANCIAL_CONTROLS = 8;
            await this.consultantService.notifyDP(this.consultant, FINANCIAL_CONTROLS, this.additiveOption);
            this.closeModalAdditive.nativeElement.click();
            if (this.additiveOption !== 2) {
                this.router.navigate(['/consultants']);
            }
            return;
        } else {
            this.toastr.info("Após o preenchimento, salve o consultor para registrar o novo aditivo.", '', { timeOut: 5000 });
        }

        if(this.additiveOption == 1) {
            this.showBtnNewAdditiveRenew = false;
            this.showBtnNewAdditiveChangeCompany = false;
        } else if(this.additiveOption == 2) {
            if(!this.validateDocumentGeneration('additiveRenovation'))
                return;
            this.consultant.contract.end = '';
            this.additiveHistory.pendingApproval = false;
            this.additiveHistory.pendingGovApproval = false;
            this.consultant.contract.additivesHistory.push(this.additiveHistory);
            this.openModalContract('additiveRenovation');
        } else if(this.additiveOption == 3) {
            this.showBtnNewAdditiveReadjustment = false;
            this.showBtnNewAdditiveRenew = false;
        }
        if (this.closeModalAdditive) this.closeModalAdditive.nativeElement.click()
        this.newAdditiveIncluded = true;
    }

    cancelOffboardingForm() {
        this.completedOffboardingForm = false;
        this.consultant.contract.termination.freshServiceOffboardingForm = new FreshServiceOffboardingForm();
        this.consultant.contract.termination.freshServiceOffboardingForm.laptopTransportType = "";
    }

    getOffboardingForm() {
        this.completedOffboardingForm = true;
    }

    loadFreshServiceOffboardingForm() {
        const {
            _id,
            name,
            email,
            contract: {kind = '', companyName = '', cnpj = ''},
            personal: {cpf = ''},
            personal: {address = ''},
            personal: {number = ''},
            personal: {district = ''},
            personal: {city = ''},
            personal: {state = ''},
            personal: {cep = ''},
        } = this.consultant;
        return {
            _id,
            name,
            email,
            cpf,
            address,
            number,
            district,
            city,
            state,
            cep,
            kind,
            companyName,
            cnpj
        }
    }

    loadOffboardingDataByConsultant() {
        if(!this.completedOffboardingForm) {
            const freshServiceOffboardingFormData = this.loadFreshServiceOffboardingForm();
            this.consultant.contract.termination.freshServiceOffboardingForm.loadData(freshServiceOffboardingFormData);
            this.consultant.contract.termination.freshServiceOffboardingForm.laptopTransportType = "";
        }
    }

    setApprovalFlag(permission: string) {
        switch (permission) {
            case GUARDS.DP:
                this.consultant.contract.termination.pendingDPApproval = false;
                this.consultant.contract.termination.pendingGovApproval = true;
                this.notifyDepartmentsForApproval();
                break;
            case GUARDS.GOVERNANCE:
                this.consultant.contract.termination.pendingGovApproval = false;
                if(this.consultant.contract.kind != ContractType.PJ) {
                    this.consultant.contract.termination.pendingDPApproval = true;
                    this.notifyDepartmentsForApproval();
                } else {
                    this.notifyInfra();
                }
                break;
            default:
                this.consultant.contract.termination.pendingGovApproval = true;
                if(this.consultant.contract.kind != ContractType.PJ)
                    this.consultant.contract.termination.pendingDPApproval = true;
                this.notifyDepartmentsForApproval();
                break;
        }
    }

    approveTermination(): void {
        const permission = this.user.permission;
        const isValueFilled = !!this.consultant.contract.termination.value;

        if (permission === GUARDS.GOVERNANCE) {
            if (!isValueFilled && this.consultantService.isContractTypePJ(this.consultant)){
                this.toastr.error('Preencha o valor a ser pago para seguir com a aprovação.', 'Erro ao aprovar');
                return;
            }

            this.consultant.contract.termination.pendingGovApproval = false;
        }
        if (permission === GUARDS.DP)
            this.consultant.contract.termination.pendingDPApproval = false;

        if (!this.consultant.contract.termination.pendingDPApproval &&
            !this.consultant.contract.termination.pendingGovApproval) {
            this.notifyInfra();
        }

        this.edit();
    }

    disapproveTermination(): void {
        if(this.consultant.contract.kind != ContractType.PJ)
            this.consultant.contract.termination.pendingDPApproval = true;
        this.consultant.contract.termination.pendingGovApproval = true;
    }

    async createServiceTicket(type: string): Promise<void> {
        const errorMessageIfFreshserviceFails = 'Não foi possível registrar automaticamente um chamado de Offboarding, acesse o Portal Infra e crie-o manualmente';
        try {
            this.loading = true;
            const freshServiceOffboardingForm = this.consultant.contract.termination.freshServiceOffboardingForm;
            const responseTicket = await this.consultantService.createTicket(freshServiceOffboardingForm, type);
            this.loading = false;
            if(responseTicket && responseTicket.success)
                this.toastr.success("Um chamado de Offboard foi registrado", "Portal Infra");
            else {
                this.toastr.warning(errorMessageIfFreshserviceFails, 'Erro no Portal Infra', { dismiss: 'controlled' })
                    .then((t: Toast) => { setTimeout(() => { this.toastr.dismissToast(t) }, 10000) });
            }
        } catch(err) {
            this.loading = false;
            this.toastr.warning(errorMessageIfFreshserviceFails, 'Erro no Portal Infra', { dismiss: 'controlled' })
                .then((t: Toast) => { setTimeout(() => { this.toastr.dismissToast(t) }, 10000) });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultant-edit/consultant-edit.component.ts